<template>
  <div class="comment-to-comment">
    <div
      ref="editableEl"
      class="contenteditable"
      contenteditable="true"
      :placeholder="placeholder"
      @blur="onBlur"
      @focus="onFocus"
      @keypress.ctrl.exact.prevent="onCtrlEnter"
      @keypress.enter.exact.prevent="onSubmit"
    ></div>
    <div class="toolbar">
      <div class="left">
        <div class="emoji-btn" @click="handleOpenEmojiPanel"></div>
      </div>
      <div class="right">
        <el-button size="mini" @click="onCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="onSubmit">回复</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { openEmojiPanel } from "@/views/wiki/components/emoji";

export default {
  name: "CommentToComment",
  props: {
    placeholder: { type: String, default: "说点什么吧" }
  },
  data() {
    return { savedRange: null };
  },
  methods: {
    onCtrlEnter(event) {
      if (event.code === "Enter") {
        document.execCommand("insertText", false, "\n");
      }
    },
    onCancel() {
      this.$emit("cancel");
      this.$refs.editableEl.innerHTML = "";
    },
    onSubmit() {
      /** @type {string} */
      const html = this.$refs.editableEl.innerHTML;
      if (!html.trim()) return this.$message.info("内容为空，请重新输入！");
      const text = html.replace(/<img[^>]*alt="([^"]*)"[^>]*>/g, "$1");
      this.$emit("submit", text);
      this.$refs.editableEl.innerHTML = "";
    },
    onBlur() {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const savedRange = selection.getRangeAt(0);
        this.savedRange = savedRange;
      }
    },
    onFocus() {
      const savedRange = this.savedRange;
      if (savedRange) {
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(savedRange);
      }
    },
    async handleOpenEmojiPanel(event) {
      this.$refs.editableEl.focus();
      const emoji = await openEmojiPanel(event.target)
        .then(value => value)
        .catch(() => null);
      if (!emoji) return;

      let sel, range;
      if (window.getSelection && (sel = window.getSelection()).rangeCount) {
        range = sel.getRangeAt(0);
        range.collapse(true);
        const img = document.createElement("img");
        img.style.width = "20px";
        img.style.height = "20px";
        img.src = emoji.icon;
        img.dataset.emoji = emoji.name;
        img.alt = emoji.name;
        range.insertNode(img);

        range.setStartAfter(img);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.comment-to-comment {
  background-color: #f5f5f5;
  border-radius: 4px;
  .contenteditable {
    padding: 14px 10px;
    overflow: hidden auto;
    max-height: 100px;
    font-size: 14px;
    user-modify: read-write-plaintext-only;
    &:empty:before {
      content: attr(placeholder);
      color: #999;
      font-size: 13px;
    }
  }
  .toolbar {
    padding: 8px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      .emoji-btn {
        width: 20px;
        height: 20px;
        position: relative;
        bottom: 1px;
        background: url("~@/assets/images/comment-emoji-btn.png") no-repeat;
        background-size: 20px 20px;
        margin-left: 6px;
        cursor: pointer;
      }
    }
  }
}
</style>
